import React from 'react';
import { useIntl } from 'react-intl';
import { KEY_STEP_MS, KEY_STEP_SHIFT_MS } from '../utils/constants';
import { formatClock } from '../utils/timeZone';
import { fromPercent, toPercent } from '../utils/timeline';

const KEY_DIRECTION = { ArrowLeft: -1, ArrowDown: -1, ArrowRight: 1, ArrowUp: 1 };

// Draggable (pointer) and focusable (keyboard) edge of the clip range.
export const TimelineHandle = ({ edge, ms, window, timeZone, trackRef, onNudge, onSetTime }) => {
  const { formatMessage } = useIntl();
  const labelId = edge === 'start' ? 'requestVideo_handle_start' : 'requestVideo_handle_end';

  const handleKeyDown = (event) => {
    const direction = KEY_DIRECTION[event.key];
    if (!direction) return;
    event.preventDefault();
    let step = KEY_STEP_MS;
    if (event.shiftKey) step = KEY_STEP_SHIFT_MS;
    onNudge(edge, direction * step);
  };

  const handlePointerDown = (event) => {
    if (event.currentTarget.setPointerCapture) event.currentTarget.setPointerCapture(event.pointerId);
  };

  const handlePointerMove = (event) => {
    const isDragging = event.currentTarget.hasPointerCapture && event.currentTarget.hasPointerCapture(event.pointerId);
    if (!isDragging || !trackRef.current) return;
    const rect = trackRef.current.getBoundingClientRect();
    if (rect.width === 0) return;
    onSetTime(edge, fromPercent((event.clientX - rect.left) / rect.width, window));
  };

  return (
    <div
      role="slider"
      tabIndex={0}
      className={`request-video-handle request-video-handle-${edge}`}
      style={{ left: `${toPercent(ms, window)}%` }}
      aria-label={formatMessage({ id: labelId })}
      aria-valuemin={window.start}
      aria-valuemax={window.end}
      aria-valuenow={ms}
      aria-valuetext={formatClock(ms, timeZone, true)}
      onKeyDown={handleKeyDown}
      onPointerDown={handlePointerDown}
      onPointerMove={handlePointerMove}
    />
  );
};
